import React from 'react'
import { View, Text, Platform } from 'react-native'
import CS from '../../../constants/Styles';
import Storage from '../../../components/Storage';
import Button from '../../../components/Button';
import UserAvatar from '../../../components/Users/UserAvatar';
import styles from './styles';
import PDFReader from 'rn-pdf-reader-js';

export const FileChange = ({ item, acceptChange, rejectChange }) => {

  const [headers, setHeaders] = React.useState({});
  const [rtJWT, setRtJWT] = React.useState(null);
  React.useEffect(() => {
    (async () => {
      const rtJWT = await Storage.getItem('rtJWT');
      setRtJWT(rtJWT);
      setHeaders({ 'Authorization': `Bearer ${rtJWT}` });
    })()
  }, []);

  const accept = () => {
    console.log('accept()');
    acceptChange(item);
  }
  const reject = () => {
    console.log('reject()');
    rejectChange(item);
  }

  return (
    <View style={CS.flex}>
      {/* <Text style={[CS.smallTitle, CS.lightText]}>Photo</Text> */}
      <View style={[CS.rowContainer, { marginBottom: 20 }]}>
        <UserAvatar userId={item.avatar.id} avatar={item.avatar.version} size='medium' />
        <Text style={[CS.smallText, CS.lightBlueText, { marginLeft: 10 }, CS.flex]}>{item.memo}</Text>
      </View>
      <View style={styles.pdfContainer}>
        {Platform.OS === 'web' ?
          <iframe
            width='100%'
            height='100%'
            src={`${item.path}?jwt=${rtJWT}`}
            frameborder='0'
          ></iframe>
          :
          <PDFReader source={{ uri: item.path, headers: headers }} />
        }
      </View>
      <View style={styles.caption}>
        <Text style={[CS.smallText, CS.lightBlueText, CS.centerText]}>{item.caption}</Text>
      </View>
      <View style={[CS.rowContainer, { marginBottom: 10 }]}>
        <View style={CS.buttonLeft}>
          <Button text='Accept' onPress={() => accept} />
        </View>
        <View style={CS.buttonRight}>
          <Button text='Reject' onPress={() => reject} color='red' />
        </View>
      </View>
    </View>
  );
}

export default FileChange;